<template>
  <Event ref="eventRef" :event="mappedEvent" @open-edit-component="show">
    <div class="font-bold">
      <div>
        <div class="flex">
          <div class="color leftside">
            {{ t("components.issueModal.technicalPlace") }}
          </div>

          <div class="w-75">
            {{ event.technicalPlace.path + " | " + event.technicalPlace.name }}
          </div>
        </div>
        <div class="flex">
          <div class="color leftside">
            {{ t("components.issueModal.failure") }}
          </div>
          <div v-if="event.failure" class="w-75">
            {{ t("global.yes").toString() + " (" + formatDate(event.faultTimeStart) }}
            <i class="fa fa-arrow-right fa-xs" />
            {{
              (event.faultTimeEnd ? formatDate(event.faultTimeEnd) : t("license.ih.ih.open")) + ")"
            }}
          </div>
          <div v-else class="w-75">{{ t("global.no") }}</div>
        </div>
        <div class="flex">
          <div class="color leftside">
            {{ t("components.issueModal.description") }}
          </div>
          <div class="w-75">{{ event.description }}</div>
        </div>
      </div>
    </div>
    <template #trailingHeaderAdditionsFront>
      <AttachmentBadge :files="mappedEvent.Folder?.files" class="inline" />
    </template>
    <template #editComponent>
      <IHFailureNoticeModal ref="editComponent" :event="eventForEditComponent" />
    </template>
  </Event>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { type PropType, computed, provide, ref } from "vue";
import { DateTime } from "luxon";
import type { EventListEventFields_IHFailureNotice_Fragment } from "@/graphql";
import Event from "@/components/event-action/event/EventComponent.vue";
import { BadgeColorInjectionKey } from "@/components/event-action/issue/IssueTypes";
import IHFailureNoticeModal from "@/modules/ih/components/IHFailureNoticeModal.vue";
import { LISA_DATE_SHORT } from "@/language/translation";
import AttachmentBadge from "@/components/badges/AttachmentBadge.vue";
import { TechnicalPlaceAndCategoryInjectionKey } from "@/views/event-action/EventActionBoardInjectionKeys";
import type { IHFailureNoticeEditType } from "@/components/event-action/event/modal/EventEditType";

const props = defineProps({
  event: {
    type: Object as PropType<EventListEventFields_IHFailureNotice_Fragment>,
    required: true,
  },
});
const eventRef = ref<InstanceType<typeof Event>>();

const eventForEditComponent = computed(
  (): IHFailureNoticeEditType => ({
    ...props.event,
    fileIds: props.event.Folder?.files.map((file) => file.id) ?? [],
  }),
);
const mappedEvent = computed(() => ({
  ...props.event,
}));
provide(BadgeColorInjectionKey, "var(--p-danger-color)");
const editComponent = ref<null | InstanceType<typeof IHFailureNoticeModal>>(null);
const show = () => {
  editComponent.value?.show();
};

const formatDate = (value: string) => {
  return DateTime.fromISO(value).toLocaleString(LISA_DATE_SHORT);
};

provide(
  TechnicalPlaceAndCategoryInjectionKey,
  computed(() => ({
    technicalCategoryId: props.event.technicalCategoryId,
    technicalPlaceId: props.event.technicalPlaceId,
  })),
);

defineExpose({
  eventRef,
});

const { t } = useTranslation();
</script>

<style lang="scss" scoped>
.color {
  color: #166b95;
}

.leftside {
  width: 150px;
}
</style>
